import * as React from 'react'

const SvgClipboardIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4233_96406)">
      <path
        d="M8.41385 6.07009L6.48439 7.99951L5.72682 7.24197C5.49803 7.01314 5.12701 7.01314 4.89818 7.24197C4.66936 7.4708 4.66936 7.84177 4.89818 8.0706L6.07006 9.24248C6.18447 9.35689 6.33443 9.41408 6.48439 9.41408C6.63436 9.41408 6.78432 9.35689 6.89869 9.24244L9.24244 6.89869C9.47127 6.66986 9.47127 6.29888 9.24244 6.07005C9.01365 5.84123 8.64264 5.84123 8.41385 6.07009Z"
        fill="white"
      />
      <path
        d="M8.41385 9.58572L6.48439 11.5151L5.72682 10.7576C5.49803 10.5288 5.12701 10.5288 4.89818 10.7576C4.66936 10.9864 4.66936 11.3574 4.89818 11.5862L6.07006 12.7581C6.18447 12.8725 6.33443 12.9297 6.48439 12.9297C6.63436 12.9297 6.78432 12.8725 6.89869 12.7581L9.24244 10.4143C9.47127 10.1855 9.47127 9.81451 9.24244 9.58568C9.01365 9.35685 8.64264 9.35685 8.41385 9.58572Z"
        fill="white"
      />
      <path
        d="M8.41385 13.1013L6.48439 15.0308L5.72682 14.2732C5.49803 14.0444 5.12701 14.0444 4.89818 14.2732C4.66936 14.502 4.66936 14.873 4.89818 15.1019L6.07006 16.2737C6.18447 16.3881 6.33443 16.4453 6.48439 16.4453C6.63436 16.4453 6.78432 16.3881 6.89869 16.2737L9.24244 13.9299C9.47127 13.7011 9.47127 13.3301 9.24244 13.1013C9.01365 12.8725 8.64264 12.8725 8.41385 13.1013Z"
        fill="white"
      />
      <path
        d="M12.3438 0.585938H4.96875C3.86418 0.585938 2.96875 1.48137 2.96875 2.58594V17.4141C2.96875 18.5186 3.86418 19.4141 4.96875 19.4141H15.0312C16.1358 19.4141 17.0312 18.5186 17.0312 17.4141V4.10555M12.3438 0.585938L17.0312 4.10555M12.3438 0.585938V3.70555C12.3438 3.92646 12.5228 4.10555 12.7437 4.10555H17.0312"
        stroke="white"
        strokeWidth="1.3"
      />
      <path
        d="M14.6875 7.07031H11.1719C10.8483 7.07031 10.5859 7.33266 10.5859 7.65625C10.5859 7.97984 10.8483 8.24219 11.1719 8.24219H14.6875C15.0111 8.24219 15.2734 7.97984 15.2734 7.65625C15.2734 7.33266 15.0111 7.07031 14.6875 7.07031Z"
        fill="white"
      />
      <path
        d="M14.6875 10.5859H11.1719C10.8483 10.5859 10.5859 10.8483 10.5859 11.1719C10.5859 11.4955 10.8483 11.7578 11.1719 11.7578H14.6875C15.0111 11.7578 15.2734 11.4955 15.2734 11.1719C15.2734 10.8483 15.0111 10.5859 14.6875 10.5859Z"
        fill="white"
      />
      <path
        d="M14.6875 14.1016H11.1719C10.8483 14.1016 10.5859 14.3639 10.5859 14.6875C10.5859 15.0111 10.8483 15.2734 11.1719 15.2734H14.6875C15.0111 15.2734 15.2734 15.0111 15.2734 14.6875C15.2734 14.3639 15.0111 14.1016 14.6875 14.1016Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4233_96406">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgClipboardIcon
